"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseByteRanges = exports.parseContentRange = exports.parseContentType = void 0;
var CRLFCRLF = '\r\n\r\n';
/*
 * Shim for 'Object.fromEntries'
 */

function itemsToObject(items) {
  if (typeof Object.fromEntries !== 'undefined') {
    return Object.fromEntries(items);
  }

  var obj = {};

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      obj[key.toLowerCase()] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
}
/**
 * Parse HTTP headers from a given string.
 * @param {String} text the text to parse the headers from
 * @returns {Object} the parsed headers with lowercase keys
 */


function parseHeaders(text) {
  var items = text.split('\r\n').map(function (line) {
    var kv = line.split(':').map(function (str) {
      return str.trim();
    });
    kv[0] = kv[0].toLowerCase();
    return kv;
  });
  return itemsToObject(items);
}
/**
 * Parse a 'Content-Type' header value to the content-type and parameters
 * @param {String} rawContentType the raw string to parse from
 * @returns {Object} the parsed content type with the fields: type and params
 */


function parseContentType(rawContentType) {
  var _rawContentType$split = rawContentType.split(';').map(function (s) {
    return s.trim();
  }),
      _rawContentType$split2 = (0, _toArray2.default)(_rawContentType$split),
      type = _rawContentType$split2[0],
      rawParams = _rawContentType$split2.slice(1);

  var paramsItems = rawParams.map(function (param) {
    return param.split('=');
  });
  return {
    type: type,
    params: itemsToObject(paramsItems)
  };
}

exports.parseContentType = parseContentType;
/**
 * Parse a 'Content-Range' header value to its start, end, and total parts
 * @param {String} rawContentRange the raw string to parse from
 * @returns {Object} the parsed parts
 */

function parseContentRange(rawContentRange) {
  var start;
  var end;
  var total;

  if (rawContentRange) {
    var _rawContentRange$matc = rawContentRange.match(/bytes (\d+)-(\d+)\/(\d+)/);

    var _rawContentRange$matc2 = (0, _slicedToArray2.default)(_rawContentRange$matc, 4);

    start = _rawContentRange$matc2[1];
    end = _rawContentRange$matc2[2];
    total = _rawContentRange$matc2[3];
    start = parseInt(start, 10);
    end = parseInt(end, 10);
    total = parseInt(total, 10);
  }

  return {
    start: start,
    end: end,
    total: total
  };
}

exports.parseContentRange = parseContentRange;
/**
 * Parses a list of byteranges from the given 'multipart/byteranges' HTTP response.
 * Each item in the list has the following properties:
 * - headers: the HTTP headers
 * - data: the sliced ArrayBuffer for that specific part
 * - offset: the offset of the byterange within its originating file
 * - length: the length of the byterange
 * @param {ArrayBuffer} responseArrayBuffer the response to be parsed and split
 * @param {String} boundary the boundary string used to split the sections
 * @returns {Object[]} the parsed byteranges
 */

function parseByteRanges(responseArrayBuffer, boundary) {
  var offset = null;
  var decoder = new TextDecoder('ascii');
  var out = [];
  var startBoundary = "--".concat(boundary);
  var endBoundary = "".concat(startBoundary, "--"); // search for the initial boundary, may be offset by some bytes
  // TODO: more efficient to check for `--` in bytes directly

  for (var i = 0; i < 10; ++i) {
    var text = decoder.decode(new Uint8Array(responseArrayBuffer, i, startBoundary.length));

    if (text === startBoundary) {
      offset = i;
    }
  }

  if (offset === null) {
    throw new Error('Could not find initial boundary');
  }

  while (offset < responseArrayBuffer.byteLength) {
    var _text = decoder.decode(new Uint8Array(responseArrayBuffer, offset, Math.min(startBoundary.length + 1024, responseArrayBuffer.byteLength - offset))); // break if we arrived at the end


    if (_text.length === 0 || _text.startsWith(endBoundary)) {
      break;
    } // assert that we are actually dealing with a byterange and are at the correct offset


    if (!_text.startsWith(startBoundary)) {
      throw new Error('Part does not start with boundary');
    } // get a substring from where we read the headers


    var innerText = _text.substr(startBoundary.length + 2);

    if (innerText.length === 0) {
      break;
    } // find the double linebreak that denotes the end of the headers


    var endOfHeaders = innerText.indexOf(CRLFCRLF); // parse the headers to get the content range size

    var headers = parseHeaders(innerText.substr(0, endOfHeaders));

    var _parseContentRange = parseContentRange(headers['content-range']),
        start = _parseContentRange.start,
        end = _parseContentRange.end,
        total = _parseContentRange.total; // calculate the length of the slice and the next offset


    var startOfData = offset + startBoundary.length + endOfHeaders + CRLFCRLF.length;
    var length = parseInt(end, 10) + 1 - parseInt(start, 10);
    out.push({
      headers: headers,
      data: responseArrayBuffer.slice(startOfData, startOfData + length),
      offset: start,
      length: length,
      fileSize: total
    });
    offset = startOfData + length + 4;
  }

  return out;
}

exports.parseByteRanges = parseByteRanges;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBTUEsUUFBUSxHQUFHLFVBQWpCO0FBRUE7Ozs7QUFHQSxTQUFTQyxhQUFULENBQXVCQyxLQUF2QixFQUE0QjtFQUMxQixJQUFJLE9BQU9DLE1BQU0sQ0FBQ0MsV0FBZCxLQUE4QixXQUFsQyxFQUErQztJQUM3QyxPQUFPRCxNQUFNLENBQUNDLFdBQVAsQ0FBbUJGLEtBQW5CLENBQVA7RUFDRDs7RUFDRCxJQUFNRyxHQUFHLEdBQUcsRUFBWjs7RUFKMEIsMkNBS0NILEtBTEQ7RUFBQTs7RUFBQTtJQUsxQixvREFBa0M7TUFBQTtNQUFBLElBQXRCSSxHQUFzQjtNQUFBLElBQWpCQyxLQUFpQjs7TUFDaENGLEdBQUcsQ0FBQ0MsR0FBRyxDQUFDRSxXQUFKLEVBQUQsQ0FBSCxHQUF5QkQsS0FBekI7SUFDRDtFQVB5QjtJQUFBO0VBQUE7SUFBQTtFQUFBOztFQVExQixPQUFPRixHQUFQO0FBQ0Q7QUFFRDs7Ozs7OztBQUtBLFNBQVNJLFlBQVQsQ0FBc0JDLElBQXRCLEVBQTBCO0VBQ3hCLElBQU1SLEtBQUssR0FBR1EsSUFBSSxDQUNmQyxLQURXLENBQ0wsTUFESyxFQUVYQyxHQUZXLENBRVAsVUFBQ0MsSUFBRCxFQUFTO0lBQ1osSUFBTUMsRUFBRSxHQUFHRCxJQUFJLENBQUNGLEtBQUwsQ0FBVyxHQUFYLEVBQWdCQyxHQUFoQixDQUFvQixVQUFDRyxHQUFEO01BQUEsT0FBU0EsR0FBRyxDQUFDQyxJQUFKLEVBQVQ7SUFBQSxDQUFwQixDQUFYO0lBQ0FGLEVBQUUsQ0FBQyxDQUFELENBQUYsR0FBUUEsRUFBRSxDQUFDLENBQUQsQ0FBRixDQUFNTixXQUFOLEVBQVI7SUFDQSxPQUFPTSxFQUFQO0VBQ0QsQ0FOVyxDQUFkO0VBUUEsT0FBT2IsYUFBYSxDQUFDQyxLQUFELENBQXBCO0FBQ0Q7QUFFRDs7Ozs7OztBQUtBLFNBQWdCZSxnQkFBaEIsQ0FBaUNDLGNBQWpDLEVBQStDO0VBQzdDLDRCQUE2QkEsY0FBYyxDQUFDUCxLQUFmLENBQXFCLEdBQXJCLEVBQTBCQyxHQUExQixDQUE4QixVQUFDTyxDQUFEO0lBQUEsT0FBT0EsQ0FBQyxDQUFDSCxJQUFGLEVBQVA7RUFBQSxDQUE5QixDQUE3QjtFQUFBO0VBQUEsSUFBT0ksSUFBUDtFQUFBLElBQWdCQyxTQUFoQjs7RUFDQSxJQUFNQyxXQUFXLEdBQUdELFNBQVMsQ0FBQ1QsR0FBVixDQUFjLFVBQUNXLEtBQUQ7SUFBQSxPQUFXQSxLQUFLLENBQUNaLEtBQU4sQ0FBWSxHQUFaLENBQVg7RUFBQSxDQUFkLENBQXBCO0VBQ0EsT0FBTztJQUFFUyxJQUFJLEVBQUpBLElBQUY7SUFBUUksTUFBTSxFQUFFdkIsYUFBYSxDQUFDcUIsV0FBRDtFQUE3QixDQUFQO0FBQ0Q7O0FBSkRHO0FBTUE7Ozs7OztBQUtBLFNBQWdCQyxpQkFBaEIsQ0FBa0NDLGVBQWxDLEVBQWlEO0VBQy9DLElBQUlDLEtBQUo7RUFDQSxJQUFJQyxHQUFKO0VBQ0EsSUFBSUMsS0FBSjs7RUFFQSxJQUFJSCxlQUFKLEVBQXFCO0lBQUEsNEJBQ0tBLGVBQWUsQ0FBQ0ksS0FBaEIsQ0FBc0IsMEJBQXRCLENBREw7O0lBQUE7O0lBQ2hCSCxLQURnQjtJQUNUQyxHQURTO0lBQ0pDLEtBREk7SUFFbkJGLEtBQUssR0FBR0ksUUFBUSxDQUFDSixLQUFELEVBQVEsRUFBUixDQUFoQjtJQUNBQyxHQUFHLEdBQUdHLFFBQVEsQ0FBQ0gsR0FBRCxFQUFNLEVBQU4sQ0FBZDtJQUNBQyxLQUFLLEdBQUdFLFFBQVEsQ0FBQ0YsS0FBRCxFQUFRLEVBQVIsQ0FBaEI7RUFDRDs7RUFFRCxPQUFPO0lBQUVGLEtBQUssRUFBTEEsS0FBRjtJQUFTQyxHQUFHLEVBQUhBLEdBQVQ7SUFBY0MsS0FBSyxFQUFMQTtFQUFkLENBQVA7QUFDRDs7QUFiREw7QUFlQTs7Ozs7Ozs7Ozs7O0FBV0EsU0FBZ0JRLGVBQWhCLENBQWdDQyxtQkFBaEMsRUFBcURDLFFBQXJELEVBQTZEO0VBQzNELElBQUlDLE1BQU0sR0FBRyxJQUFiO0VBQ0EsSUFBTUMsT0FBTyxHQUFHLElBQUlDLFdBQUosQ0FBZ0IsT0FBaEIsQ0FBaEI7RUFDQSxJQUFNQyxHQUFHLEdBQUcsRUFBWjtFQUVBLElBQU1DLGFBQWEsZUFBUUwsUUFBUixDQUFuQjtFQUNBLElBQU1NLFdBQVcsYUFBTUQsYUFBTixPQUFqQixDQU4yRCxDQVEzRDtFQUNBOztFQUNBLEtBQUssSUFBSUUsQ0FBQyxHQUFHLENBQWIsRUFBZ0JBLENBQUMsR0FBRyxFQUFwQixFQUF3QixFQUFFQSxDQUExQixFQUE2QjtJQUMzQixJQUFNaEMsSUFBSSxHQUFHMkIsT0FBTyxDQUFDTSxNQUFSLENBQ1gsSUFBSUMsVUFBSixDQUFlVixtQkFBZixFQUFvQ1EsQ0FBcEMsRUFBdUNGLGFBQWEsQ0FBQ0ssTUFBckQsQ0FEVyxDQUFiOztJQUdBLElBQUluQyxJQUFJLEtBQUs4QixhQUFiLEVBQTRCO01BQzFCSixNQUFNLEdBQUdNLENBQVQ7SUFDRDtFQUNGOztFQUVELElBQUlOLE1BQU0sS0FBSyxJQUFmLEVBQXFCO0lBQ25CLE1BQU0sSUFBSVUsS0FBSixDQUFVLGlDQUFWLENBQU47RUFDRDs7RUFFRCxPQUFPVixNQUFNLEdBQUdGLG1CQUFtQixDQUFDYSxVQUFwQyxFQUFnRDtJQUM5QyxJQUFNckMsS0FBSSxHQUFHMkIsT0FBTyxDQUFDTSxNQUFSLENBQ1gsSUFBSUMsVUFBSixDQUFlVixtQkFBZixFQUFvQ0UsTUFBcEMsRUFDRVksSUFBSSxDQUFDQyxHQUFMLENBQVNULGFBQWEsQ0FBQ0ssTUFBZCxHQUF1QixJQUFoQyxFQUFzQ1gsbUJBQW1CLENBQUNhLFVBQXBCLEdBQWlDWCxNQUF2RSxDQURGLENBRFcsQ0FBYixDQUQ4QyxDQU85Qzs7O0lBQ0EsSUFBSTFCLEtBQUksQ0FBQ21DLE1BQUwsS0FBZ0IsQ0FBaEIsSUFBcUJuQyxLQUFJLENBQUN3QyxVQUFMLENBQWdCVCxXQUFoQixDQUF6QixFQUF1RDtNQUNyRDtJQUNELENBVjZDLENBWTlDOzs7SUFDQSxJQUFJLENBQUMvQixLQUFJLENBQUN3QyxVQUFMLENBQWdCVixhQUFoQixDQUFMLEVBQXFDO01BQ25DLE1BQU0sSUFBSU0sS0FBSixDQUFVLG1DQUFWLENBQU47SUFDRCxDQWY2QyxDQWlCOUM7OztJQUNBLElBQU1LLFNBQVMsR0FBR3pDLEtBQUksQ0FBQzBDLE1BQUwsQ0FBWVosYUFBYSxDQUFDSyxNQUFkLEdBQXVCLENBQW5DLENBQWxCOztJQUVBLElBQUlNLFNBQVMsQ0FBQ04sTUFBVixLQUFxQixDQUF6QixFQUE0QjtNQUMxQjtJQUNELENBdEI2QyxDQXdCOUM7OztJQUNBLElBQU1RLFlBQVksR0FBR0YsU0FBUyxDQUFDRyxPQUFWLENBQWtCdEQsUUFBbEIsQ0FBckIsQ0F6QjhDLENBMkI5Qzs7SUFDQSxJQUFNdUQsT0FBTyxHQUFHOUMsWUFBWSxDQUFDMEMsU0FBUyxDQUFDQyxNQUFWLENBQWlCLENBQWpCLEVBQW9CQyxZQUFwQixDQUFELENBQTVCOztJQUNBLHlCQUE4QjNCLGlCQUFpQixDQUFDNkIsT0FBTyxDQUFDLGVBQUQsQ0FBUixDQUEvQztJQUFBLElBQVEzQixLQUFSLHNCQUFRQSxLQUFSO0lBQUEsSUFBZUMsR0FBZixzQkFBZUEsR0FBZjtJQUFBLElBQW9CQyxLQUFwQixzQkFBb0JBLEtBQXBCLENBN0I4QyxDQStCOUM7OztJQUNBLElBQU0wQixXQUFXLEdBQUdwQixNQUFNLEdBQUdJLGFBQWEsQ0FBQ0ssTUFBdkIsR0FBZ0NRLFlBQWhDLEdBQStDckQsUUFBUSxDQUFDNkMsTUFBNUU7SUFDQSxJQUFNQSxNQUFNLEdBQUdiLFFBQVEsQ0FBQ0gsR0FBRCxFQUFNLEVBQU4sQ0FBUixHQUFvQixDQUFwQixHQUF3QkcsUUFBUSxDQUFDSixLQUFELEVBQVEsRUFBUixDQUEvQztJQUNBVyxHQUFHLENBQUNrQixJQUFKLENBQVM7TUFDUEYsT0FBTyxFQUFQQSxPQURPO01BRVBHLElBQUksRUFBRXhCLG1CQUFtQixDQUFDeUIsS0FBcEIsQ0FBMEJILFdBQTFCLEVBQXVDQSxXQUFXLEdBQUdYLE1BQXJELENBRkM7TUFHUFQsTUFBTSxFQUFFUixLQUhEO01BSVBpQixNQUFNLEVBQU5BLE1BSk87TUFLUGUsUUFBUSxFQUFFOUI7SUFMSCxDQUFUO0lBUUFNLE1BQU0sR0FBR29CLFdBQVcsR0FBR1gsTUFBZCxHQUF1QixDQUFoQztFQUNEOztFQUVELE9BQU9OLEdBQVA7QUFDRDs7QUFyRURkIiwibmFtZXMiOlsiQ1JMRkNSTEYiLCJpdGVtc1RvT2JqZWN0IiwiaXRlbXMiLCJPYmplY3QiLCJmcm9tRW50cmllcyIsIm9iaiIsImtleSIsInZhbHVlIiwidG9Mb3dlckNhc2UiLCJwYXJzZUhlYWRlcnMiLCJ0ZXh0Iiwic3BsaXQiLCJtYXAiLCJsaW5lIiwia3YiLCJzdHIiLCJ0cmltIiwicGFyc2VDb250ZW50VHlwZSIsInJhd0NvbnRlbnRUeXBlIiwicyIsInR5cGUiLCJyYXdQYXJhbXMiLCJwYXJhbXNJdGVtcyIsInBhcmFtIiwicGFyYW1zIiwiZXhwb3J0cyIsInBhcnNlQ29udGVudFJhbmdlIiwicmF3Q29udGVudFJhbmdlIiwic3RhcnQiLCJlbmQiLCJ0b3RhbCIsIm1hdGNoIiwicGFyc2VJbnQiLCJwYXJzZUJ5dGVSYW5nZXMiLCJyZXNwb25zZUFycmF5QnVmZmVyIiwiYm91bmRhcnkiLCJvZmZzZXQiLCJkZWNvZGVyIiwiVGV4dERlY29kZXIiLCJvdXQiLCJzdGFydEJvdW5kYXJ5IiwiZW5kQm91bmRhcnkiLCJpIiwiZGVjb2RlIiwiVWludDhBcnJheSIsImxlbmd0aCIsIkVycm9yIiwiYnl0ZUxlbmd0aCIsIk1hdGgiLCJtaW4iLCJzdGFydHNXaXRoIiwiaW5uZXJUZXh0Iiwic3Vic3RyIiwiZW5kT2ZIZWFkZXJzIiwiaW5kZXhPZiIsImhlYWRlcnMiLCJzdGFydE9mRGF0YSIsInB1c2giLCJkYXRhIiwic2xpY2UiLCJmaWxlU2l6ZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9kaXN0LW1vZHVsZS9zb3VyY2UvaHR0cHV0aWxzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19